import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {CountryDomainModel} from "../../common/country/models/country-domain-model";
import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {CompetitionsResponseApiModel} from "./competitions.response-api-model";
import {CompetitorCompetitionsDomainModel} from "../../common/competitor/models/competitor-competitions.domain-model";

export class CompetitionsResponseDomainModel extends BaseDomainDataSource {
  apiModel: CompetitionsResponseApiModel;
  competitions: Array<CompetitionDomainModel>;
  countries: Array<CountryDomainModel>;
  sports: Array<CountryDomainModel>;
  competitors: Array<CompetitorCompetitionsDomainModel>;

  constructor(response: CompetitionsResponseApiModel, competitions: Array<CompetitionDomainModel>, competitors: Array<CompetitorCompetitionsDomainModel>, countries: Array<CountryDomainModel>, sports: Array<SportDomainModel>) {
    super(response);

    this.competitions = competitions;
    this.competitors = competitors;
    this.countries = countries;
    this.sports = sports;
  }
}
